// ©2024 Austin App House. All rights reserved.
import React from "react";
import {MDBBtn} from "mdbreact";

const ControlErrorButton = ({onClick, label}) => (
    <button
        color='info'
        className='signbutton'
        onClick={onClick}
    >
        {label}
    </button>
)

export default ControlErrorButton;